import $ from "jquery";

function _getTime() {
	let el = document.querySelector(".ytp-time-duration");
	let text = el.innerText;
	let seconds = 0;
	let minutes = 0;
	let hours = 0;
	text = text.split(":");
	if (text.length === 3) {
		hours = text[0];
		minutes = text[1];
		seconds = text[2];
	} else {
		minutes = text[0] || 0;
		seconds = text[1] || 0;
	}
	return {
		hours: parseInt(hours),
		minutes: parseInt(minutes),
		seconds: parseInt(seconds),
	};
}

function isYoutubePage() {
	let url = new URL(window.location.href);
	if (url.hostname === "www.youtube.com" && url.pathname === "/watch") {
		return true;
	} else {
		let el = $("#player .html5-video-player");
		return false;
	}
}

function _getTimelinePercentage(x) {
	let el = document.querySelector(".ytp-progress-list");
	let rect = el.getBoundingClientRect();
	let width = rect.width;
	let percentage = (x / width) * 100;
	return percentage;
}

function _getTimelinePercentageDifference(percentage, seconds) {
	return (percentage * seconds) / 100;
}

function _secondsToMinutes(seconds) {
	let minutes = Math.floor(seconds / 60);
	seconds = Math.floor(seconds - minutes * 60);
	return {
		minutes: minutes,
		seconds: seconds,
	};
}

function _scaleValue(value, from, to) {
	var scale = (to[1] - to[0]) / (from[1] - from[0]);
	var capped = Math.min(from[1], Math.max(from[0], value)) - from[0];
	return ~~(capped * scale + to[0]);
}

function _secondsToPosition(seconds, totalSeconds) {
	let el = document.querySelector(".ytp-progress-list");
	if (!el) {
		return 0;
	}
	let rect = el.getBoundingClientRect();
	let width = rect.width;
	let result = _scaleValue(seconds, [0, totalSeconds], [0, width]);
	return result;
}

function _durationToPosition(duration, totalSeconds) {
	duration = duration / 1000;
	let el = document.querySelector(".ytp-progress-list");
	if (!el) {
		return 0;
	}
	let rect = el.getBoundingClientRect();
	let width = rect.width;
	let result = _scaleValue(duration, [0, totalSeconds], [0, width]);
	return result;
}

function getYoutubeBoundingClientRect() {
	let el = document.querySelector(".ytp-progress-list");
	let rect = el.getBoundingClientRect();
	return rect;
}

function getTimelineDifference(x) {
	let time = _getTime();
	let seconds = lalal(time.hours, time.minutes, time.seconds);
	let percentage = _getTimelinePercentage(x);
	let diff = _getTimelinePercentageDifference(percentage, seconds);
	let newTime = _secondsToMinutes(diff);
	return newTime;
}

function getTotalTime() {
	return _getTime();
}

function createMark(id, data, color) {
	color = color || "c1";
	let seconds = lalal(
		data.timestamp.time.hours || 0,
		data.timestamp.time.minutes,
		data.timestamp.time.seconds
	);

	let totalSeconds = lalal(
		data.timestamp.totalTime.hours || 0,
		data.timestamp.totalTime.minutes,
		data.timestamp.totalTime.seconds
	);

	let length = _durationToPosition(data.duration, totalSeconds);
	let offset = 0;
	if (length < 14) {
		length = 14;
	}
	if (data.position === "center") {
		offset = length / 2;
	}
	length = length + "px";
	let left = _secondsToPosition(seconds, totalSeconds) - offset + "px";
	let el = `<span class="underlineme-mark video-mark ${color}" data-private-id="${id}" style="width:${length};left:${left}"><span>`;
	let container = $(".ytp-chrome-bottom");
	if (container) {
		container.append(el);
	}
}

function lalal(hours, minutes, seconds) {
	if (typeof hours === "object") {
		minutes = hours.minutes || 0;
		seconds = hours.seconds || 0;
		hours = hours.hours || 0;
	}
	seconds = seconds || 0;
	if (minutes > 0) {
		seconds = minutes * 60 + seconds;
	}
	if (hours > 0) {
		seconds = hours * 3600 + seconds;
	}
	return seconds;
}

let youtubeHelper = {
	isYoutubePage: isYoutubePage,
	getTotalTime: getTotalTime,
	getYoutubeBoundingClientRect: getYoutubeBoundingClientRect,
	getTimelineDifference: getTimelineDifference,
	createMark: createMark,
	timeToSeconds: lalal,
	scaleValue: _scaleValue,
};

export default youtubeHelper;
